import { Routes, Route, useNavigate, Navigate } from "react-router-dom";

import Home from "../Home/Home";
import Navbar from "../Navbar/Navbar";
import Notfound from "../Notfound/Notfound";
import Register from "../Register/Register";
import Login from "./../Login/Login";

import { useState } from "react";
import jwtDecode from "jwt-decode";
import { useEffect } from "react";
import { MediaContextProvider } from "../../MediaContext";
import Blog from "../Blog/blog";

function App() {
  const [userData, setUserData] = useState(null);
  let navigate = useNavigate();

  useEffect(() => {
    if (sessionStorage.getItem("userToken")) {
      console.log(sessionStorage.getItem("userToken"));
      getUserData();
    }
  }, []);

  function getUserData() {
    let decodedToken = jwtDecode(sessionStorage.getItem("userToken"));
    setUserData(decodedToken);
  }

  function logOut() {
    sessionStorage.removeItem("userToken");
    setUserData(null);
    navigate("/login");
  }

  function ProtectedRoute({ children }) {
    if (!sessionStorage.getItem("userToken")) {
      return <Navigate to="/login" />;
    } else {
      return children;
    }
  }

  return (
    <>
      <Navbar userData={userData} logOut={logOut} />

      <MediaContextProvider>
        <Routes>
          <Route path="/" element={<Login />}></Route>
          <Route
            index={true}
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          ></Route>
          <Route
            path="/blog"
            element={
              <ProtectedRoute>
                <Blog />
              </ProtectedRoute>
            }
          ></Route>

          {/* <Route
            path="/showmessages"
            element={
              <ProtectedRoute>
                <ShowMessages />
              </ProtectedRoute>
            }
          ></Route> */}

          <Route path="/register" element={<Register />}></Route>
          <Route
            path="/login"
            element={<Login getUserData={getUserData} />}
          ></Route>

          <Route path="*" element={<Notfound />}></Route>
        </Routes>
      </MediaContextProvider>
    </>
  );
}

export default App;
